import { fetchOrchidAPI } from "utils/api";
import { getErrorDetail } from "components/utility/utils.js";

export default async function switchBackToGuardian() {
  const res = await fetchOrchidAPI(
    "/api/users/v1/minors/switch_back_to_guardian",
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to switch back to guardian: ${getErrorDetail(await res.text())}`,
    );
  }

  return;
}
